<template>
  <v-row
    class="list-item-wrapper is-clickable justify-space-between no-gutters pa-2 mb-2 card-text-color"
    align="center"
    style="cursor: pointer"
  >
    <v-col class="col-auto mr-4 order-0" @click="goToDetailsPage">
      <v-icon color="primary" large>fas fa-file-invoice</v-icon>
    </v-col>
    <v-col class="col-12 col-sm order-2 order-sm-1">
      <div class="subtitle-2 font-weight-bold">
        <span @click="goToDetailsPage">
          {{ billAppointment?.hService?.longDescr }}
        </span>
        <span @click="goToDetailsPage">&nbsp;&#45;&nbsp;</span>
        <span @click="goToDetailsPage">
          {{ billAppointment.iupCode }}
        </span>
        <span v-if="billAppointment.iupCode">
          <base-copy-button
            :copiedText="copiedText"
            :valueToCopy="billAppointment.iupCode"
          ></base-copy-button>
        </span>
        <span @click="goToDetailsPage">
          <v-chip
            color="success"
            class="white--text font-weight-bold caption text-uppercase state-chip"
            >{{
              $t(`billAppointments.states.${billAppointment.state}`)
            }}</v-chip
          >
        </span>
      </div>
      <v-row
        class="no-gutters fill-height body-2 font-weight-medium"
        @click="goToDetailsPage"
      >
        <v-col class="col-12 col-sm-6">
          <span
            v-if="billAppointment && billAppointment.appointmentScheduleDate"
            >{{ $t("billAppointments.scheduleDate") }}&#58;&nbsp;{{
              billAppointment.appointmentScheduleDate | date(dateTimeFormat)
            }}</span
          >
          <span v-else class="font-italic text-uppercase">{{
            $t("emptyData")
          }}</span>
        </v-col>
        <v-col class="col-12 col-sm-6">
          <span>{{ doctorFullName }}</span>
        </v-col>
        <v-col class="col-12 col-sm-6">
          <span
            v-if="
              billAppointment &&
              billAppointment.memberName &&
              billAppointment.memberSurname
            "
            >{{ billAppointment.memberName }}&nbsp;{{
              billAppointment.memberSurname
            }}</span
          >
          <span v-else class="font-italic text-uppercase">{{
            $t("emptyData")
          }}</span>
          <span>&nbsp;&#45;&nbsp;</span>
          <span v-if="billAppointment && billAppointment.memberCodiceFiscale">{{
            billAppointment.memberCodiceFiscale
          }}</span>
          <span v-else class="font-italic text-uppercase">{{
            $t("emptyData")
          }}</span>
        </v-col>
        <v-col class="col-12 col-sm-6">
          <span>{{ servicePrice }}</span>
        </v-col>
      </v-row>
    </v-col>
    <v-col class="col-auto order-1 order-sm-2" @click="goToDetailsPage">
      <v-btn rounded icon small @click.stop="updateBillAppointment()">
        <v-icon v-if="isBillAppointmentSelected" color="primary"
          >fas fa-check-square</v-icon
        >
        <v-icon v-else color="primary">far fa-square</v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import findIndex from "lodash/findIndex";
import BaseCopyButton from "../BaseCopyButton";

export default {
  components: {
    BaseCopyButton
  },
  props: {
    billAppointment: {
      type: Object,
      required: true
    },
    selectedBillAppointments: {
      type: Array,
      required: false
    }
  },
  data() {
    return {
      copiedText: this.$t("iupCodeCopied"),
      dateTimeFormat: "DD/MM/YYYY HH:mm"
    };
  },
  created() {
    this.selectedBillApps = [...this.selectedBillAppointments];
  },
  computed: {
    doctorFullName() {
      return this.billAppointment.doctorId &&
        this.billAppointment.doctorName &&
        this.billAppointment.doctorSurname
        ? `${this.$t("billAppointments.doctorShort")} ${
            this.billAppointment.doctorName
          } ${this.billAppointment.doctorSurname}`
        : " - ";
    },
    servicePrice() {
      let price = this.billAppointment.price
        ? this.billAppointment.price.slice(4, this.billAppointment.price.length)
        : null;
      return price
        ? this.$options.filters.decimals(price, 2) + " €"
        : this.$t("emptyData");
    },
    isBillAppointmentSelected() {
      let billAppointmentIndex = findIndex(this.selectedBillAppointments, {
        appointmentId: this.billAppointment.appointmentId
      });
      return billAppointmentIndex !== -1;
    }
  },
  methods: {
    updateBillAppointment() {
      let action = this.isBillAppointmentSelected ? "remove" : "add";
      this.$emit(
        "billappointmentupdated",
        this.billAppointment.appointmentId,
        action
      );
    },
    removeBillAppointmentFromList() {
      this.$emit(
        "removebillappointmentfromlist",
        this.billAppointment.appointmentId
      );
    },
    goToDetailsPage() {
      this.$router.push({
        name: "_appointmentManagement",
        params: { id: this.billAppointment.appointmentId }
      });
    }
  }
};
</script>

<style scoped>
.list-item-wrapper {
  background-color: white;
}

.bill-appointment-card {
  border-radius: 6px;
  width: 99.5%;
  margin-left: auto;
  margin-right: auto;
}

.bill-appointment-card.selected {
  width: 100%;
  background-color: #dfe4ea;
}

.bill-appointment-card:first-child {
  margin-top: 0 !important;
}

.bill-appointment-card-header {
  padding: 16px 12px;
}

.bill-appointment-card-body {
  padding: 16px 12px 8px;
}

.state-chip {
  height: auto;
  min-height: 24px;
  margin-bottom: 3px;
}
.state-chip >>> .v-chip__content {
  height: auto !important;
}
</style>
